import products from 'api/definitions/products';

import get from 'lodash/get';

import { LEGACY_PRODUCTS_SCHEMA } from 'redux/schemas';
import { TRANSFORM_PRODUCTS_INTO_LEGACY_FORMAT } from 'redux/transforms';

const notFoundStatuses = [400, 404];

export const getProducts = types => properties => {
  const start = get(properties, 'start', 0);
  const size = get(properties, 'size', 0);
  return {
    start,
    size,
    types,
    apiCall: products.get({
      ...properties,
      start: String(start),
    }),
    schema: LEGACY_PRODUCTS_SCHEMA,
    transform: TRANSFORM_PRODUCTS_INTO_LEGACY_FORMAT,
    doNotHandleHttpStatuses: notFoundStatuses,
  };
};
